















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class Avatar extends Vue {
    @Prop() userId!: number
    @Prop() nickname!: string
    @Prop() size!: number
    @Prop() imagePath!: string

    fontSize: string = '1em'
    colors = [
        '#f44336',
        '#9c27b0',
        '#2196f3',
        '#4caf50',
        '#ffeb3b',
        '#ff9800',
        '#ff5722',
        '#795548',
    ]

    mounted() {
        this.fontSize = this.size
            ? `${this.size * 0.5}px`
            : `${this.$el.offsetWidth * 0.5}px`
    }

    get color() {
        return this.colors[this.userId % this.colors.length]
    }

    get initials() {
        const parts = this.nickname.split('.')

        if (parts.length === 2) {
            return (parts[0][0] + parts[1][0]).toUpperCase()
        }

        return ''
    }
}
